import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import VueMask from 'v-mask'

import routes from './router/routes.js'
import store from './store/'
import authMiddleware from './router/middleware/auth'
import activePropertyMiddleware from './router/middleware/activeProperty'
import checkAccountLinkingMiddleware from './router/middleware/checkAccountLinking'
// import lessorOnly from './router/middleware/lessorOnly'
import VueTour from 'vue-tour'
import VueLogger from 'vuejs-logger'
import VueSocketIOExt from 'vue-socket.io-extended'
import io from 'socket.io-client'
import { VTextField } from 'vuetify/lib' //Globally import VTextField
import VCurrencyField from 'v-currency-field'
import 'vue-tour/dist/vue-tour.css'
import './styles/variables.scss'
import { registerLongPressDirective } from './util/longPressDirective'

const isProduction = process.env.NODE_ENV === 'production'

const loggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}

Vue.use(VueRouter)
Vue.use(VueTour)
Vue.use(VueLogger, loggerOptions)
Vue.use(VueMask)
Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
  locale: 'en-PH',
  decimalLength: 2,
  autoDecimalMode: false,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: true,
  allowNegative: true
})

const socket = io(process.env.VUE_APP_SOCKET_URL)

Vue.use(VueSocketIOExt, socket)

// Register directives
registerLongPressDirective(Vue)

Vue.config.productionTip = false

const router = new VueRouter({
  routes // short for `routes: routes`
})

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context
  })
})

router.beforeEach((to, from, next) => {
  if (to.meta.skipAuth) {
    return next()
  }

  const context = {
    to,
    from,
    next,
    store
  }
  return authMiddleware({
    ...context
  })
})

router.beforeEach((to, from, next) => {
  if (to.meta.skipAuth || to.meta.skipPropertyCheck) {
    return next()
  }

  const context = {
    to,
    from,
    next,
    store
  }
  return activePropertyMiddleware({
    ...context
  })
})

router.beforeEach((to, from, next) => {
  if (to.meta.skipAuth) {
    return next()
  }

  const context = {
    to,
    from,
    next,
    store
  }
  return checkAccountLinkingMiddleware({
    ...context
  })
})

// router.beforeEach((to, from, next) => {
//   if(!to.meta.lessorOnly) {
//     return next()
//   }

//   const context = {
//     to,
//     from,
//     next,
//     store
//   }
//   return lessorOnly({
//     ...context
//   })
// })

new Vue({
  store,
  vuetify,
  router,
  render: (h) => h(App)
}).$mount('#app')
